import React, { useEffect, useRef, useState } from 'react';
import * as echarts from 'echarts';
import { getEquipmentStatusColor } from 'data/data';
import { getDashboardCountByZoneAndEquipmentStatus } from './axios/dashboardAxios';

const DELAY_TIME = Number(process.env.REACT_APP_DELAY_TIME) || 60000;

export default function EchartsChinaMap() {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const [mapZones, setMapZones] = useState([]);
  const isFetchingRef = useRef(false);

  // 1. API 데이터 페칭 (깜빡임 방지를 위해 mapZones 업데이트)
  useEffect(() => {
    const fetchMapZones = async () => {
      if (isFetchingRef.current) return;
      isFetchingRef.current = true;

      try {
        const res = await getDashboardCountByZoneAndEquipmentStatus();
        const list = Array.isArray(res) ? res : [];

        const positions = list.map((info, i) => ({
          content: `
            <div class="map_pin"
                style="min-width: 160px;
                  background: unset;"
              >
              <div
                style="width: 100%;
                  padding: 10px;
                  border-radius: 10px;
                  border : 1px solid #fff;
                  color: #000;"
              >
                <div style="border-radius:10px; width:100%; background:${getEquipmentStatusColor(info.countO1N, info.countO2I, info.countO3A, info.countO4C)?.bg};">
                  <h4 style="padding:5px; color: #fff; text-align: center; font-size: 18px;">${info.managementCompanyName} (${info.name})</h4>
                </div>
                <div class="kakaomap_circle" style="display : flex; align-items :center;justify-content:space-evenly; margin:10px 0 7px 0;">
                  <div class="map_pin0"><span class="pin1">${info.countO1N}</span><span class="pin2">${info.countO2I}</span><span class="pin3">${info.countO3A}</span></div>
                </div>
              </div>
            </div>
          `,
          lat: info.latitude,
          lng: info.longitude,
          color: getEquipmentStatusColor(
            info.countO1N,
            info.countO2I,
            info.countO3A,
            info.countO4C
          )?.marker,
          link: `/dashboard/sub?zId=${info.id}`,
        }));
        setMapZones(positions);
      } catch (e) {
        console.error("Data Loading fail", e);
      } finally {
        isFetchingRef.current = false;
      }
    };

    fetchMapZones();
    const intervalId = setInterval(fetchMapZones, DELAY_TIME);
    return () => clearInterval(intervalId);
  }, []);

  // 2. 차트 초기화 및 데이터 업데이트
  useEffect(() => {
    const initOrUpdateChart = async () => {
      if (!chartRef.current) return;

      // 최초 실행 시 지도 데이터 로드 및 차트 초기화
      if (!chartInstance.current) {
        const res = await fetch("/data/china-cities.json");
        const data = await res.json();
        echarts.registerMap('china', data);

        const myChart = echarts.init(chartRef.current);
        chartInstance.current = myChart;

        // 기본 옵션 설정 (데이터 제외)
        myChart.setOption({
          backgroundColor: "#f8f9fa",
          geo: {
            map: 'china',
            roam: true,
            label: { show: false },
            itemStyle: { areaColor: '#e9ecef', borderColor: '#d1d1d1' },
            emphasis: { itemStyle: { areaColor: '#dee2e6' } }
          },
          tooltip: {
            show: true,
            trigger: 'item',
            backgroundColor: 'transparent',
            borderWidth: 0,
            padding: 0,
            enterable: true, // 툴팁 안으로 마우스 진입 허용 (링크 클릭용)
            position: (point, params, dom, rect, size) => [
              rect.x + (rect.width / 2) - (size.contentSize[0] / 2), 
              rect.y - size.contentSize[1] - 10
            ],
            formatter: (params) => params.data?.content || params.name
          }
        });

        myChart.on('click', (params) => {
          if (params.data?.link) window.location.href = params.data.link;
        });

        window.addEventListener('resize', () => myChart.resize());
      }

      // 데이터 매핑 로직 (차트 인스턴스가 있을 때만 실행)
      if (mapZones.length > 0) {
        const chartData = mapZones.map(site => {
          const coords = [site.lng, site.lat];
          return {
             ...site
            , value: coords
            , symbol : `image:///markers/${site.color}.svg`
          };
        }).filter(d => d.value);

        // [핵심] dispose() 없이 데이터만 업데이트하여 깜빡임 방지
        chartInstance.current.setOption({
          series: [{
            type: 'scatter',
            coordinateSystem: 'geo',
            // symbol: 'pin',
            symbolSize: [18, 20],
            data: chartData,
            label: { show: true, formatter: '{b}', position: 'right', fontSize: 10 },
            animationDuration: 5000, // 요청하신 애니메이션 속도 적용
            animationEasing: 'elasticOut'
          }]
        });
      }
    };

    initOrUpdateChart();
  }, [mapZones]);

  return (
    <div style={{ width: '100%', height: '655px' }}>
      <div ref={chartRef} style={{ width: '100%', height: '100%' }} />
    </div>
  );
}